import {gql} from "apollo-boost";
import {STUDENT_NAME_FIELDS, TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_STUDENTENROLLDETAIL = gql`
  query getStudentEnrollDetail($id: ID!) {
    getStudentEnrollDetail(
      id: $id
    ) {
      id enrollNo studentCode sectionNo subjectCode teacherCode
      credit learnSpanNo examSpanNo isDrop
      courseOutlineRegistration{
        id periodCode
        academicPeriod{
          id
        }
      }
      classSection{
        id studentRegisterQty studentQty
      }
      subject{
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
      }
      studentEnroll{
        id enrollNo periodCode studentCode enrollDate
        totalCredit totalDropCredit source
        academicPeriod{
          id periodCode
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENTENROLLDETAILS = gql`
  query getStudentEnrollDetails {
    getStudentEnrollDetails {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
        isSpecialTeacher
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_STUDENTENROLLDETAILS_BY_FILTER = gql`
  query getStudentEnrollDetailsByFilter(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsByFilter(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      courseOutlineRegistration{
        id
        courseOutline {
          id
        }
      }
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng creditCalGrade creditDesc
      }
      classSection{
        id
        classAssignments{
          id
        }
      }
      student {
        ...StudentNameFields
        picturePath
      }
      studentAssignments{
        id remark studentSendDate teacherReceiveDate isTeacherReceive
        uploadPath uploadPathUri uploadFileName
        classSection {
          id sectionNo
        }
        classAssignment {
          id topicLocal topicEng descriptionLocal descriptionEng score dueDate
        }
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;


export const GET_STUDENTENROLLDETAILS_BY_FILTER_FOR_HOME_WORK = gql`
  query getStudentEnrollDetailsByFilter(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsByFilter(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id isDrop dropType
      student {
        ...StudentNameFields
        picturePath
      }
      studentAssignments{
        id remark studentSendDate teacherReceiveDate isTeacherReceive
        uploadPath uploadPathUri uploadFileName studentCode latitude longitude
        classAssignment {
          id
        }
      }
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_STUDENT_IN_CLASS_SECTION_BY_CODE_OR_NAME = gql`
  query getStudentsInClassSectionByCodeOrName(
    $academicPeriodId: ID!
  ) {
    getStudentsInClassSectionByCodeOrName(
      academicPeriodId: $academicPeriodId
    ) {
      id studentCode
      classSection { id sectionNo }
      courseOutlineRegistration {
        id subjectCode
        academicPeriod { id }
      }
      student {
        ...StudentNameFields
        user {
          id
          code
        }
      }

    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const GET_TEACHERS_IN_STUDENT_ENROLL_BY_CODE_OR_NAME_CURRENT_USER = gql`
  query getTeachersInStudentEnrollByCodeOrNameCurrentUser(
    $academicPeriodId: ID!
  ) {
    getTeachersInStudentEnrollByCodeOrNameCurrentUser(
      academicPeriodId: $academicPeriodId
    ) {
      id teacherCode
      classSection { id sectionNo }
      courseOutlineRegistration {
        id subjectCode
        academicPeriod { id }
      }
      teacher {
        ...TeacherNameFields
        user {
          id
          code
        }
      }
      subjectCode

    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_STUDENTENROLLDETAILS_STAT = gql`
  query getStudentEnrollDetailsStat(
    $studentEnrollDetailFilterInput: StudentEnrollDetailFilterInput
  ) {
    getStudentEnrollDetailsStat(
      studentEnrollDetailFilterInput: $studentEnrollDetailFilterInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      student {
        ...StudentNameFields
        picturePath
        telephone
      }
      #manual data
      expandData {
        seq totalVdoLength totalLearnTime learnPercent
        pretestMaxScore pretestScore posttestMaxScore posttestScore
        pretestDone posttestDone
      }
      studentAssignmentQty
      totalVdoLength
      totalLearnTime
      totalLearnPercent
    }
  }

  ${STUDENT_NAME_FIELDS}
`;

export const ADD_STUDENTENROLLDETAILS = gql`
  mutation addStudentEnrollDetailss(
    $studentEnrollDetailsInput: [StudentEnrollDetailsInput!]
  )
  {
    addStudentEnrollDetails ( studentEnrollDetailsInput: $studentEnrollDetailsInput ){
      id enrollNo studentCode sectionNo subjectCode teacherCode
      credit learnSpanNo examSpanNo isDrop
      courseOutlineRegistration{
        id periodCode
      }
      classSection{
        id studentRegisterQty studentQty
      }
      subject{
        id code nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
      }
      student {
        ...StudentNameFields
      }
      studentEnroll{
        id enrollNo periodCode studentCode enrollDate
        totalCredit totalDropCredit source
        academicPeriod{
          id periodCode
        }
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
  ${STUDENT_NAME_FIELDS}
`;

export const UPDATE_STUDENTENROLLDETAIL = gql`
  mutation updateStudentEnrollDetail(
    $id: ID!,
    $studentEnrollDetailInput: StudentEnrollDetailInput!,
    $studentEnrollId: ID,
    $studentId: ID,
    $courseOutlineRegistrationId: ID,
    $classSectionId: ID,
    $subjectId: ID,
    $teacherId: ID
  ) {
    updateStudentEnrollDetail (
      id: $id
      studentEnrollDetailInput: $studentEnrollDetailInput
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
        isSpecialTeacher
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const UPDATE_STUDENTENROLLDETAIL_IS_DROP = gql`
  mutation updateStudentEnrollDetailIsDrop(
    $id: ID!, $isDrop: Boolean!
  ) {
    updateStudentEnrollDetailIsDrop (
      id: $id, isDrop: $isDrop
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
        isSpecialTeacher
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_STUDENTENROLLDETAIL = gql`
  mutation deleteStudentEnrollDetail(
    $id: ID!
  ) {
    deleteStudentEnrollDetail (
      id: $id
    ) {
      id enrollNo studentCode sectionNo
      subjectCode teacherCode credit learnSpanNo examSpanNo isDrop
      studentEnroll {
        id
      }
      subject{
        id nameLocal nameEng
      }
      teacher {
        ...TeacherNameFields
        picturePath
        isSpecialTeacher
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;


